require("!!/Users/maxBook/Sites/haendlerfromular/backend/bookstore/node_modules/script-loader/addScript.js")(require("!!/Users/maxBook/Sites/haendlerfromular/backend/bookstore/node_modules/raw-loader/index.js!/Users/maxBook/Sites/haendlerfromular/backend/bookstore/node_modules/clarity-icons/clarity-icons.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/clarity-icons/clarity-icons.min.js
// module id = 263
// module chunks = 3